// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3uDCH","overflowing":"ReadFullNote_overflowing__QN-sH"};